<ng-template #content let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-6 offset-md-3 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                                Bancos
                                
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</ng-template>


<div class="mt-md-3 p-3">

    <div class="row ">
        <div class=" col-12 col-md-8 offset-md-2">

            <div class="dd-head">
                <div>
                    <h5 class="dd-head__title">Domiciliaciones</h5>
                    <div class="dd-head__sub">Bancos</div>
                </div>
                <div class="dd-head__actions">
                    <button *ngIf="!_auth.hasRbac$.getValue() || _auth.hasPermission('cobranza.domiciliaciones.dashboard')"
                            class="btn btn-outline-secondary btn-sm" routerLink="/console/domiciliation-config">
                        <i class="fas fa-cog me-1"></i>
                        Dashboard
                    </button>
                    <button class="btn btn-outline-primary btn-sm" routerLink="/console/direct-debit-history">
                        <i class="fas fa-history me-1"></i>
                        Histórico
                    </button>
                </div>
            </div>
            <!-- <a href="javascript:void()" (click)="conciliar_manual()">Conciliar Manul</a> -->
            <!-- {{ pending.resp[0] | json }} <br>
            {{ date | json }} -->
            <ng-container *ngIf="pending?.resp?.length>0">
                <!-- {{ date }} {{ current_date }} -->
            <!-- <div class="alert alert-danger" role="alert" *ngIf="date!==current_date">
                Se ha detectado que posee un proceso activo de un día anterior, por favor culmine el proceso para iniciar el del día actual
              </div> -->
            </ng-container>

                <div class="col-12 text-end pt-2">
                    <form autocomplete="nope" novalidate [formGroup]="form" class="text-start dd-filters">

                    <div class="dd-filters__head">
                        <h6 class="dd-filters__title">Configuración del lote</h6>
                    </div>

                    <div class="row mt-2">
                        <!-- ============================================================
                             SELECTOR DE FLUJO (segmented button) — arriba de todo
                             ============================================================ -->
                        <div class="form-group col-12 mt-1 flujo-selector-block">
                            <label class="form-label small text-uppercase fw-semibold text-muted mb-1 d-block letter-spacing-1">
                                Flujo de generación
                            </label>
                            <div class="flujo-segmented" role="group" aria-label="Flujo de generación">
                                <button type="button"
                                        class="flujo-segmented__btn"
                                        [class.is-active]="flujo === 'standard'"
                                        (click)="flujo = 'standard'; onFlujoChange()">
                                    <i class="fas fa-bolt me-2"></i>
                                    <span class="flujo-segmented__text">
                                        <span class="flujo-segmented__title">Estándar</span>
                                        <span class="flujo-segmented__sub">Domiciliación activa</span>
                                    </span>
                                </button>
                                <button type="button"
                                        class="flujo-segmented__btn flujo-segmented__btn--special"
                                        [class.is-active]="flujo === 'special'"
                                        (click)="flujo = 'special'; onFlujoChange()">
                                    <i class="fas fa-history me-2"></i>
                                    <span class="flujo-segmented__text">
                                        <span class="flujo-segmented__title">Especial</span>
                                        <span class="flujo-segmented__sub">Domiciliaciones pausadas temporalmente del flujo normal</span>
                                    </span>
                                </button>
                            </div>

                        </div>

                        <!-- Selector de tipo de producto con autocompletar -->
                        <div class="form-group col-12 mt-4">
                            
                            <!-- Buscador de productos con dropdown -->
                            <div class="position-relative product-search-input">
                                <div class="form-floating">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="productSearch"
                                        [(ngModel)]="productSearchTerm"
                                        [ngModelOptions]="{standalone: true}"
                                        (input)="filterProducts()"
                                        (focus)="showProductOptions()"
                                        (click)="showProductOptions()"
                                        (blur)="hideProductOptions()"
                                        [readonly]="!showProductDropdown"
                                        placeholder="Buscar tipo de producto..."
                                        autocomplete="off">
                                    <label for="productSearch">
                                        <i class="fas fa-search me-2"></i>
                                        Buscar tipo de producto
                                    </label>
                                    <!-- Botón limpiar (no mostrar si el producto es CREDIT) -->
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-secondary position-absolute end-0 top-50 translate-middle-y me-2"
                                        *ngIf="productSearchTerm && form.get('product')?.value !== 'CREDIT'"
                                        (click)="clearProductSearch()"
                                        style="z-index: 10;">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>

                                <!-- Dropdown de productos -->
                                <div
                                    class="product-search-dropdown"
                                    *ngIf="showProductDropdown && filteredProducts.length > 0">

                                    <!-- Header del dropdown -->
                                    <div class="px-3 py-2 dropdown-header-info">
                                        <small>
                                            <i class="fas fa-list me-1"></i>
                                            {{filteredProducts.length}} producto{{filteredProducts.length > 1 ? 's' : ''}} encontrado{{filteredProducts.length > 1 ? 's' : ''}}
                                        </small>
                                    </div>

                                    <!-- Lista de productos -->
                                    <div class="list-group list-group-flush">
                                        <button
                                            type="button"
                                            class="list-group-item list-group-item-action d-flex align-items-center py-3"
                                            *ngFor="let product of filteredProducts; let i=index"
                                            (click)="selectProduct(product)"
                                            [ngClass]="{'selected': form.get('product')?.value === product?.params?.code}">
                                            <div class="me-3">
                                                <i class="fas fa-cube text-primary fa-lg"></i>
                                            </div>
                                            <div class="flex-grow-1">
                                                <h6 class="mb-1 fw-bold text-dark">{{ product?.params?.name || product?.name || product?.params?.code }}</h6>
                                                <small class="text-muted">Código: {{ product?.params?.code }}</small>
                                            </div>
                                            <div class="ms-2">
                                                <i class="fas fa-chevron-right text-muted"></i>
                                            </div>
                                        </button>
                                    </div>
                                </div>

                                <!-- Mensaje cuando no hay resultados -->
                                <div
                                    class="product-search-dropdown"
                                    *ngIf="showProductDropdown && filteredProducts.length === 0 && productSearchTerm">
                                    <div class="no-results-message">
                                        <i class="fas fa-search fa-2x"></i>
                                        <h6 class="text-muted">No se encontraron productos</h6>
                                        <small class="text-muted">Intenta con otro término de búsqueda</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Información de la tasa del producto -->
                        <div class="col-12 mt-2" *ngIf="productRateInfo || loadingRateInfo || rateInfoError">
                            <div class="dd-rate" [ngClass]="{'border-danger': rateInfoError}">
                                <div class="py-1 px-0" [ngClass]="{'bg-danger bg-opacity-10': rateInfoError}">
                                    <div class="d-flex align-items-center">
                                        <div class="me-2">
                                            <i class="fas fa-exchange-alt text-primary" *ngIf="!loadingRateInfo && !rateInfoError"></i>
                                            <i class="fas fa-spinner fa-spin text-primary" *ngIf="loadingRateInfo"></i>
                                            <i class="fas fa-exclamation-triangle text-danger" *ngIf="rateInfoError && !loadingRateInfo"></i>
                                        </div>
                                        <div class="flex-grow-1 small">
                                            <ng-container *ngIf="loadingRateInfo">
                                                <span class="text-secondary">Cargando información de tasa…</span>
                                            </ng-container>
                                            <ng-container *ngIf="!loadingRateInfo && productRateInfo && !rateInfoError">
                                                <strong class="text-dark">{{ productRateInfo.rate_name }}</strong>
                                            </ng-container>
                                            <ng-container *ngIf="!loadingRateInfo && rateInfoError">
                                                <strong class="text-danger">{{ rateInfoErrorMessage }}</strong>
                                                <span class="text-muted ms-2">
                                                    La tasa para este tipo de producto no está disponible.
                                                </span>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-6 dd-col-half mt-2">
                            <div class="form-floating">
                                <select class="form-select" id="bank" formControlName="bank" aria-label="Floating label select example" (change)="updateCurrentDirectDebit()">
                                        <option value="">Seleccione un banco</option>
                                        <option *ngFor="let item of (availableBanks?.length ? availableBanks : banks); let i=index" [value]="item?.code">
                                            {{ item.name }}
                                        </option>
                                </select>
                                <label for="bank">Entidad Bancaria</label>
                            </div>
                        </div>

                        <div class="form-group col-6 dd-col-half mt-2">
                            <div class="form-floating">
                                <select class="form-select" id="type" formControlName="type" aria-label="Floating label select example" (change)="updateCurrentDirectDebit()">
                                        <option *ngFor="let item of displayedTypes; let i=index" [value]="item?.id">
                                            {{ item.name }}
                                        </option>
                                </select>
                                <label for="origin_account">Tipo</label>
                            </div>
                        </div>

                    </div>

                    </form>
                    <!-- <button type="button" class="btn-close" aria-label="Close" (click)=" view > 1 ? view = 1 : offcanvas.dismiss('Cross click'); "></button> -->
                </div>

                <div class="mt-3 list-group list-group-radio d-grid gap-2 border-0 w-auto">

                    <!-- Resumen compacto del lote actual -->
                    <div *ngIf="current_direct_debit && current_direct_debit.total_amount > 0"
                         class="mb-2">
                        <div>
                            <div class="dd-lotehead">
                                <div>
                                    <div class="dd-lotehead__k">Lote</div>
                                    <div class="dd-lotehead__v">
                                        {{ current_direct_debit.lote }}
                                        <span *ngIf="current_direct_debit.manual_lote" class="text-secondary fw-normal ms-2">· Nro. {{ current_direct_debit.manual_lote }}</span>
                                        <!-- El número del banco lo teclea una persona y se carga mal a
                                             menudo. Se puede corregir mientras el proceso siga vivo. -->
                                        <span *ngIf="usaLoteManual() && !current_direct_debit.manual_lote"
                                              class="text-warning fw-normal ms-2 fst-italic small">· Nro. sin asignar</span>
                                        <a *ngIf="puedeEditarLoteManual()"
                                           href="javascript:void(0)"
                                           (click)="editarLoteManual()"
                                           class="ms-2 small text-decoration-none"
                                           [title]="current_direct_debit.manual_lote ? 'Corregir el número de lote del banco' : 'Asignar el número de lote del banco'">
                                            <i class="fas fa-edit"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="text-end">
                                    <div class="dd-lotehead__amount">{{ current_direct_debit.total_amount }} Bs</div>
                                    <div class="dd-lotehead__sub">
                                        <span *ngIf="current_direct_debit.rate">BCV {{ current_direct_debit.rate }} Bs</span>
                                        <span class="mx-1" *ngIf="current_direct_debit.rate">·</span>
                                        <span>Actualizado {{ current_direct_debit.date | date: 'dd/MM/yyyy HH:mm' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Selector multi-lote — solo Diario estándar.
                         Permite ver/gestionar lotes activos de días previos y, si no hay
                         lote para HOY, generarlo aunque queden anteriores en proceso. -->
                    <div *ngIf="!isSpecialFlow && form?.getRawValue()?.type == 1 && (activeLotes.length > 0 || canOfferTodayLote())"
                         class="card mb-2 border-0 shadow-sm">
                        <div class="card-body py-2 px-3">
                            <div class="dd-label">
                                <i class="fas fa-layer-group me-1"></i> Lotes activos
                            </div>
                            <div class="d-flex flex-wrap gap-2">
                                <div *ngFor="let lote of activeLotes"
                                     class="dd-lote active-cursor"
                                     [class.is-active]="selectedLoteId === lote._id"
                                     [class.is-active]="selectedLoteId === lote._id"
                                     (click)="selectLote(lote._id)">
                                    <div class="dd-lote__date">
                                        <i class="fas fa-circle me-1 dd-lote__dot"
                                           [class.text-primary]="selectedLoteId === lote._id"
                                           [class.text-secondary]="selectedLoteId !== lote._id"></i>
                                        {{ lote.date | date: 'dd/MM/yyyy' }}
                                    </div>
                                    <div class="dd-lote__meta">
                                        {{ lote.lote }} · {{ lote.status }}
                                    </div>
                                </div>
                                <div *ngIf="canOfferTodayLote()"
                                     class="dd-lote dd-lote--new active-cursor"
                                     [class.is-active]="wantsTodayLote"
                                     [class.is-active]="wantsTodayLote"
                                     (click)="selectTodayPlaceholder()">
                                    <div class="dd-lote__date">
                                        <i class="fas fa-plus me-1"
                                           [class.text-primary]="wantsTodayLote"
                                           [class.text-secondary]="!wantsTodayLote"></i>
                                        Generar lote de hoy {{ getTodayDate() | date: 'dd/MM/yyyy' }}
                                    </div>
                                    <div class="dd-lote__meta">
                                        Aún no existe lote para hoy
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- *ngFor="let item of section_transactions"  -->
                    <div *ngFor="let section of sections; let i = index" class="position-relative dd-step"
                         [class.dd-done]="status_sections[section.status.trim()]!=='PENDING'">

                        <label class="list-group-item py-3 dd-step__body" for="listGroupRadioGrid1">
                            <ng-container *ngIf="!loading">

                                <!-- {{ profiles | json }}
                                {{ profile | json }} -->
                                    <!-- <div class="inner-box">1 -->
                                <div class="row">
                                    <div class="col-md-1 col-2 dd-step__marker">
                                    <div class="dd-circle" [class.completed]="status_sections[section.status.trim()]!=='PENDING'">
                                        {{ (i+1) }}
                                            <i class="fas fa-check verification-icon"></i>
                                    </div>
                                    <!-- {{ status_sections[section.status.trim()] | json }} -->
                                </div>

                                <div class="col-md-11 col-10">
                                    <span class="dd-step__title">{{ section.name }}</span>
                                    <!-- Marca de POSICIÓN, no de actividad: dice en qué paso estás parado.
                                         No debe afirmar que algo se está ejecutando, porque varios pasos
                                         están esperando una acción tuya (descargar, confirmar, subir). -->
                                    <span class="dd-step__now"><span class="dot"></span> Paso actual</span>
                                    <div class="dd-step__meta" *ngIf="status_sections[section.status]!=='PENDING'"><i class="far fa-clock"></i> {{ status_sections[section.status]?.date | date: 'dd/MM/yyyy h:mm:ss a'}}</div>
                                    <div class="dd-step__meta" *ngIf="status_sections[section.status].user"><i class="fas fa-user" aria-hidden="true"></i> {{ status_sections[section.status]?.user?.name + ' ' + status_sections[section.status]?.user?.lastName }}</div>


                                    <div class="dd-actions" *ngIf="section.status==='INITIAL' && status_sections[section.status]==='PENDING' && _auth.hasAccessOrProfile('cobranza', ['OWNER']) && _auth.hasPermission('cobranza.domiciliaciones.update') && !current_direct_debit "><!-- && profile['key']==='OWNER'-->
                                        <div class="d-flex flex-column align-items-end">
                                            <button 
                                                type="button" 
                                                class="btn btn-primary btn-sm" 
                                                (click)="startDirectDebit()"
                                                [disabled]="rateInfoError || loadingRateInfo"
                                                [title]="rateInfoError ? 'No se puede iniciar: La tasa no está disponible' : ''">
                                                <i class="fas fa-circle-notch fa-spin" *ngIf="loading_section[section.status] && !current_direct_debit "></i> 
                                                <i class="fas fa-exclamation-triangle me-1" *ngIf="rateInfoError"></i>
                                                Iniciar
                                            </button>
                                            <small class="text-danger mt-1" *ngIf="rateInfoError">
                                                <i class="fas fa-ban me-1"></i>Tasa no disponible
                                            </small>
                                        </div>

                                    </div>
                                    <div class="pt-3 w-100" *ngIf="section.status==='INITIAL' && current_direct_debit ">
                                        <app-direct-debit-trace-document [setType]="'DIRECTDEBIT_GENERATE_START_'+current_direct_debit.trace" (trace)="updateCurrentDirectDebit()" (response)="setResponse($event, 'START')" *ngIf="startTraceDocument"></app-direct-debit-trace-document>
                                        <div class="dd-actions" *ngIf="btn_restart">
                                            <button type="button" class="btn btn-danger btn-sm  " (click)="restart_process()"><i class="fas fa-circle-notch fa-spin" *ngIf="loading_section[section.status] "></i> Reintentar. </button>&nbsp;
                                        </div>
                                    </div>

                                    <span class="w-100" *ngIf="section.status==='GENERATED' && status_sections[section.status]!=='PENDING'">
                                        
                                        <div class="files-list">
                                            <div class="single-file active-cursor" title="Descargar" >
                                                <img src="assets/public/images/ic-file.svg" width="45px" alt="file">
                                                <div class="info">
                                                <h4 class="name small">
                                                    <a href="javascript:void()" (click)="downloadFile(status_sections[section.status]?.url, 'txt', current_direct_debit.lote)" class="active-cursor" title="Descargar Archivo de Cobranza">Descargar Archivo de Cobranza</a>
                                                </h4>
                                                <p class="size">
                                                    {{ '' }}
                                                </p>
                                                
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </span>

                                    
                                    <span *ngIf="section.status==='UPLOADED'">
                                        <div class="dd-actions" *ngIf="section.status==='UPLOADED' && status_sections[section.status]==='PENDING' && _auth.hasAccessOrProfile('cobranza', ['OWNER']) && _auth.hasPermission('cobranza.domiciliaciones.update') && status_sections['DOWNLOADED']!=='PENDING'"><!-- && profile['key']==='OWNER'-->
                                            <button type="button" class="btn btn-danger btn-sm pr-4" (click)="cancel_process()"><i class="fas fa-circle-notch fa-spin" *ngIf="loading_section[section.status] "></i> Cancelar</button>&nbsp;
                                            <button type="button" class="btn btn-primary btn-sm" (click)="confirm_upload()"><i class="fas fa-circle-notch fa-spin" *ngIf="loading_section[section.status] "></i> Confirmar</button>
                                        </div>
                                    </span>



                                    <span *ngIf="section.status==='PROCESING'">

                                        <!-- <div class="pt-3">
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar" style="width: 39%;" aria-valuenow="39" aria-valuemin="0" aria-valuemax="100">39%</div>
                                            </div>
                                        </div> -->


                                        <ng-container *ngIf="status_sections['UPLOADED']!=='PENDING' && status_sections['UPLOADED']!=='' && _auth.hasAccessOrProfile('cobranza', ['FINANCIAL', 'OWNER']) && _auth.hasPermission('cobranza.domiciliaciones.update') "><!-- && profile['key']==='ADMIN'-->

                                            <!-- 🧪 SELECTOR DE MODO: REAL vs TEST (Solo OWNER y NO en producción) -->
                                            <div class="border rounded mb-2 mt-2 px-3 py-2 d-flex align-items-center justify-content-between gap-3 flex-wrap"
                                                 *ngIf="!isProduction && _auth.IsPermitid(['OWNER']) && status_sections['PROCESING']==='PENDING'">
                                                <div class="d-flex align-items-center gap-2 min-w-0">
                                                    <i class="fas fa-vial"
                                                       [class.text-warning]="testMode"
                                                       [class.text-primary]="!testMode"></i>
                                                    <div class="lh-sm">
                                                        <div class="fw-semibold small">Modo de Conciliación</div>
                                                        <div class="text-secondary" style="font-size: 11px;">
                                                            {{ testMode ? 'Simulación con datos generados' : 'Archivo del banco requerido' }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="btn-group btn-group-sm" role="group" aria-label="Modo de conciliación">
                                                    <button type="button"
                                                            class="btn"
                                                            [class.btn-primary]="!testMode"
                                                            [class.btn-outline-secondary]="testMode"
                                                            (click)="testMode = false; onTestModeChange()">
                                                        <i class="fas fa-file-invoice me-1"></i> Real
                                                    </button>
                                                    <button type="button"
                                                            class="btn"
                                                            [class.btn-warning]="testMode"
                                                            [class.btn-outline-secondary]="!testMode"
                                                            (click)="testMode = true; onTestModeChange()">
                                                        <i class="fas fa-flask me-1"></i> Test
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- 📄 MODO REAL: Drag & Drop de archivo -->
                                            <div class="w-100 mt-2" *ngIf="!response_trace_conciliation && !testMode">
                                                <app-dnd (response)="getResponse($event)" [config]="config_read" (reset)="reset($event)" [direct_debit]="current_direct_debit" *ngIf="status_sections['PROCESING']==='PENDING' && current_direct_debit"></app-dnd>
                                                <span class="dd-actions" *ngIf="show_conciliacion_button"><button class="btn btn-primary btn-sm" [class.disabled]="loading_section[section.status]" (click)="conciliar()"><i class="fas fa-circle-notch fa-spin" *ngIf="loading_section[section.status]"></i> Conciliar</button></span>

                                            </div>

                                            <!-- 🧪 MODO TEST: Configuración de escenarios -->
                                            <div *ngIf="testMode && status_sections['PROCESING']==='PENDING'" class="mt-3">
                                              <div class="card border-warning">
                                                <div class="card-header bg-warning bg-opacity-10">
                                                  <h6 class="mb-0">
                                                    <i class="fas fa-flask me-2"></i>
                                                    Configuración de Prueba
                                                  </h6>
                                                </div>
                                                <div class="card-body">
                                                  
                                                  <!-- Preset de escenarios -->
                                                  <div class="mb-3">
                                                    <label class="form-label fw-bold">Escenario de Prueba</label>
                                                    <select class="form-select" [(ngModel)]="testPreset" [ngModelOptions]="{standalone: true}" (change)="applyTestPreset()">
                                                      <option value="all_success">✅ Todo Exitoso (100% aprobado)</option>
                                                      <option value="realistic">🎯 Realista (70% exitoso, 20% parcial, 10% error)</option>
                                                      <option value="mixed_50">⚖️ Mixto 50/50 (50% exitoso, 50% error)</option>
                                                      <option value="all_errors">❌ Todo Rechazado (100% error)</option>
                                                      <option value="custom">⚙️ Personalizado</option>
                                                    </select>
                                                  </div>

                                                  <!-- Configuración personalizada -->
                                                  <div *ngIf="testPreset === 'custom'" class="border rounded p-3 bg-light">
                                                    <div class="row">
                                                      <div class="col-md-4 mb-2">
                                                        <label class="form-label small">% Exitosos</label>
                                                        <input type="number" class="form-control form-control-sm" 
                                                               [(ngModel)]="testConfig.success_rate" 
                                                               [ngModelOptions]="{standalone: true}"
                                                               min="0" max="100">
                                                      </div>
                                                      <div class="col-md-4 mb-2">
                                                        <label class="form-label small">% Parciales</label>
                                                        <input type="number" class="form-control form-control-sm" 
                                                               [(ngModel)]="testConfig.partial_rate" 
                                                               [ngModelOptions]="{standalone: true}"
                                                               min="0" max="100">
                                                      </div>
                                                      <div class="col-md-4 mb-2">
                                                        <label class="form-label small">% Rechazados</label>
                                                        <input type="number" class="form-control form-control-sm" 
                                                               [(ngModel)]="testConfig.error_rate" 
                                                               [ngModelOptions]="{standalone: true}"
                                                               min="0" max="100">
                                                      </div>
                                                    </div>
                                                    <small class="text-muted">
                                                      <i class="fas fa-info-circle me-1"></i>
                                                      Total debe sumar 100%
                                                    </small>
                                                  </div>

                                                  <!-- Información del lote -->
                                                  <div class="alert alert-info mt-3 mb-0">
                                                    <i class="fas fa-info-circle me-2"></i>
                                                    <strong>Lote:</strong> {{ current_direct_debit?.lote }}
                                                    <br>
                                                    <small>Se generarán datos simulados según el escenario seleccionado</small>
                                                  </div>

                                                </div>
                                                <div class="card-footer">
                                                  <button 
                                                    class="btn btn-warning w-100" 
                                                    (click)="conciliarTest()"
                                                    [disabled]="loading_section['PROCESING'] || !isTestConfigValid()">
                                                    <i class="fas fa-flask me-2"></i>
                                                    <i class="fas fa-circle-notch fa-spin me-2" *ngIf="loading_section['PROCESING']"></i>
                                                    Ejecutar Conciliación de Prueba
                                                  </button>
                                                </div>
                                              </div>
                                            </div>

                                            

                                            <div class="pt-3 w-100" >
                                                
                                                <app-direct-debit-trace-document 
                                                    #traceDocumentComponent
                                                    [setType]="'DIRECTDEBIT_GENERATE_CONCILIATION_'+current_direct_debit.trace" 
                                                    (trace)="updateCurrentDirectDebit()" 
                                                    (response)="setResponse($event, 'CONCILIATION')"  
                                                    *ngIf="startTraceDocumentDomiciliation">
                                                </app-direct-debit-trace-document>

                                                <!-- 📊 MONITOR DE PROGRESO EN TIEMPO REAL -->
                                                <app-conciliation-progress-monitor
                                                    #progressMonitorComponent
                                                    [traceType]="'DIRECTDEBIT_GENERATE_CONCILIATION_'+current_direct_debit.trace"
                                                    [directDebitId]="current_direct_debit._id"
                                                    [onComplete]="onConciliationComplete.bind(this)"
                                                    *ngIf="current_direct_debit">
                                                </app-conciliation-progress-monitor>
                                                
                                                <!-- Barra de acciones: agrupa los botones que antes flotaban sueltos
                                                     (cada uno en su propio float-end, apilándose en orden inverso). -->
                                                <div class="dd-actions">
                                                    <div *ngIf="btn_restart_conciliation">
                                                        <button type="button" class="btn btn-danger btn-sm  " (click)="restart_process_conciliation()"><i class="fas fa-circle-notch fa-spin" *ngIf="loading_section[section.status] "></i> Reintentar </button>
                                                    </div>

                                                    <!-- Botón de Reiniciar Proceso (solo para OWNER cuando el trace está activo y NO hay respuesta del banco) -->
                                                    <div *ngIf="(startTraceDocumentDomiciliation || response_trace_conciliation) && _auth.hasAccessOrProfile('cobranza', ['OWNER']) && _auth.hasPermission('cobranza.domiciliaciones.update') && status_sections['PROCESING']==='PENDING'">
                                                        <button
                                                            type="button"
                                                            class="btn btn-warning btn-sm"
                                                            (click)="resetTraceProcess()"
                                                            title="Reiniciar el proceso de conciliación (requiere contraseña)">
                                                            <i class="fas fa-redo-alt me-1"></i> Reiniciar Proceso
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>


                                        </ng-container>


                                        
                                        <div class="w-100" *ngIf="status_sections['PROCESING']!=='PENDING'">
                                        <div class="files-list" >
                                            <div class="single-file active-cursor" title="Descargar" >
                                                <img src="assets/public/images/ic-file.svg" width="45px" alt="file">
                                                <div class="info">
                                                  <h4 class="name small">
                                                    <a href="javascript:void()" (click)="downloadFile(status_sections[section.status]?.url, 'txt', 'domiciliacion_respuestabanco_'+current_direct_debit.lote)"  class="active-cursor" title="Descargar Archivo de Domiciliación">Descargar Respuesta Banco</a>

                                                  </h4>
                                                  <p class="size">
                                                    {{ '' }}
                                                  </p>
                                                  
                                                </div>
                                                
                                            </div>
                                        </div>
                                        </div>
                                        
                                        


                                    </span>

                                    <span *ngIf="section.status==='FINISHED'">
                                       
                                        
                                        <div class="w-100" *ngIf="status_sections['FINISHED']!=='PENDING'">
                                        <div class="files-list" >
                                            <div class="single-file active-cursor" title="Descargar" >
                                                <img src="assets/public/images/ic-file.svg" width="45px" alt="file">
                                                <div class="info">
                                                  <h4 class="name small">
                                                    <a href="javascript:void()" (click)="downloadFile(status_sections[section.status]?.url, 'xlsx', 'domiciliacion_resultado_'+current_direct_debit.lote)" class="active-cursor" title="Descargar Archivo de Domiciliación Corrida">Descargar Respuesta Conciliación</a>
                                                  </h4>
                                                  <p class="size">
                                                    {{ '' }}
                                                  </p>
                                                </div>
                                            </div>

                                            <div class="single-file active-cursor" title="Descargar" *ngIf="status_sections[section.status]?.url_failed">
                                                <img src="assets/public/images/ic-file.svg" width="45px" alt="file">
                                                <div class="info">
                                                  <h4 class="name small">
                                                    <a href="javascript:void()" (click)="downloadFile(status_sections[section.status]?.url_failed, 'xlsx', 'domiciliacion_resultado_general_'+current_direct_debit.lote)" class="active-cursor" title="Descargar Archivo de Domiciliación Resumen">Descargar Respuesta Conciliación (General)</a>
                                                  </h4>
                                                  <p class="size">
                                                    {{ '' }}
                                                  </p>
                                                </div>
                                            </div>

                                        </div>
                                        <span class="dd-actions" ><button class="btn btn-primary btn-sm" (click)="finalizar()" >Finalizar</button></span>

                                    </div>
                                    </span>
</div>
                                </div>

                                
                                   
                            </ng-container>
                            <ng-container *ngIf="loading">
                                <div class="col-12 text-center">
                                    Cargando...
                                </div>
                            </ng-container>
                         </label>
                         
                    </div>

                   

                   


                </div>

            <ng-container *ngIf="loading">
                <div class="w-100 text-center mt-2">
                    <img src="./assets/public/images/loading.gif  " alt=" ">
                </div>
            </ng-container>

           

        </div>
    </div>

</div>